import { render } from "./Statistics.vue?vue&type=template&id=15b2d8b2&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"

import "./Statistics.vue?vue&type=style&index=0&id=15b2d8b2&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b2d8b2"]])

export default __exports__